import { User } from '~/jobiqo/models/user';
import { EventParameters } from '~/jobiqo/lib/analytics';
import { PathContextInterface } from '~/jobiqo/models/app';

/**
 * Returns the custom code for the Webtrekk. This code will be added to the Webtrekk tracking script.
 */
export const getWebtrekkCustomCode = () => {
  return '';
};

/**
 * Returns the custom analytics dimensions for a Webtrekk page view event.
 *
 * @param {User} user
 *   The current user.
 * @param {PathContextInterface} pathContext
 *  The path context.
 * @returns {EventParameters}
 *  The custom dimensions object for this job.
 */
export const getWebtrekkPageViewDimensions = (
  user: User | null = null,
  pathContext: PathContextInterface,
): EventParameters => {
  return {};
};
